import React from 'react';
import moment from "moment";
import { Link } from 'react-router';
import API from "../base/API";
import Auth from "../auth/Auth";
import Storage from "../base/Storage";
import SorTable from "../base/SorTable";
import DeleteButton from "../base/DeleteButton";
import { translate } from "../base/Translation";

export default class Forms extends Auth {

	constructor(props) {
		super(props);

		this.api = new API({
			get_forms: "/form/list?limit_from=:from&limit_max=:to",
			delete_form: "/form/delete/:form"
		});

		this.state = {
			limit_from: 0,
			limit_to: 99999,
			forms: [],
			tableData: [],
			tableColumns: [
				{ name: "name", display: translate("Názov"), sort: true, width: 79 },
				{ name: "date_created", display: translate("Vytvorené"), sort: true, width: 9 },
				{ name: "date_updated", display: translate("Upravené"), sort: true, width: 9 },
				{ name: "options", display: " ", width: 3 }
			]
		};
	}

	convertDataForTable(data) {
		return data.map(function (form) {
			let data = {};
			data.id = form.id;
			data.name = <Link to={"/forms/edit/" + form.id}>{form.name}</Link>;
			data.date_created = moment(form.created.date).format("D.M.Y");
			data.date_updated = moment(form.updated.date).format("D.M.Y");
			data.options = <DeleteButton onClick={this.onDelete.bind({ form: form.id, currentComponent: this })} permission="FormEdit" />;
			return data;
		}.bind(this));
	}

	fetchData() {
		this.api.request({
			cache: true,
			route: "get_forms",
			params: { from: this.state.limit_from, to: this.state.limit_to },
			success: (response) => {
				let tableData = this.convertDataForTable(response);
				this.setState({ forms: response, tableData });
			}
		});
	}

	componentDidMount() {
		this.fetchData();
	}

	onDelete(evt) {
		this.currentComponent.api.request({
			route: "delete_form",
			params: { form: this.form },
			success: (response) => {
				this.currentComponent.fetchData();
			}
		});
	}

	render() {
		return (
			<SorTable columns={this.state.tableColumns}
				data={this.state.tableData}
				headers={true}
				searchBy="name"
				title={translate("Dotazníky")} right={() => {
					if (Storage.get("allowed_components").indexOf("FormNew") === -1) {
						return "";
					}
					return (
						<Link to={"/forms/add/new"} className="btn btn-success btn-sm pull-right"><i className="fa fa-plus" /> {translate("Pridať")}</Link>
					)
				}} />
		);
	}
}


// WEBPACK FOOTER //
// ./src/modules/form/Forms.js